export const showCookieSettings = () => {
  if (window?.OneTrust?.ToggleInfoDisplay) {
    // eslint-disable-next-line new-cap
    window.OneTrust.ToggleInfoDisplay();
  }
};
